/**
 * Hintergrund sperren, solange ein Side-Panel offen ist.
 *
 * Suche, Warenkorb, Filter, Produkt-Drawer und Kundenkonto oeffnen und
 * schliessen sich an rund zehn Stellen in app.js, product.js, facets.js,
 * predictive-search.js und customer.js - per Button, Klick auf den
 * Hintergrund, ESC. Statt jede Stelle anzufassen, beobachtet dieses Skript
 * den Zustand: Traegt <body> open-cc oder open-cc--product UND ist ein
 * .side-panel aktiv, oder ist der Warenkorb-Drawer offen
 * (body.js-show-ajax-cart), ist gesperrt. Oeffnet sich ein zweites Panel aus dem
 * ersten heraus (Produkt-Drawer aus der Suche), bleibt es bei einer Sperre;
 * frei wird erst, wenn keines mehr offen ist.
 *
 * Warum nicht position: fixed am body: Die Kopfzeile ist position: sticky.
 * Ein fixierter body schiebt sie aus dem Bild, die Seite springt hinter dem
 * Panel. Stattdessen:
 *   - html/body overflow: hidden (Desktop, Android, iOS ab 16)
 *   - touchmove wird ausserhalb scrollbarer Panel-Bereiche und an deren
 *     Raendern abgefangen (aeltere iOS-Versionen reichen den Wisch sonst an
 *     die Seite weiter)
 * Die Seite bewegt sich dabei nie - die Scrollposition bleibt von selbst
 * erhalten.
 */
(function () {
  if (window.S4TScrollLock) return;

  var root = document.documentElement;
  var locked = false;
  var lastX = 0;
  var lastY = 0;

  // Offene Panels: Side-Panels des Themes und der Warenkorb-Drawer
  // (#my-cart, sections/cart-drawer.liquid, body.js-show-ajax-cart).
  var PANEL = '.side-panel.active, body.js-show-ajax-cart .my-cart';

  function panelOpen() {
    var b = document.body;
    if (!b) return false;
    if (b.classList.contains('js-show-ajax-cart') && document.getElementById('my-cart')) return true;
    if (!b.classList.contains('open-cc') && !b.classList.contains('open-cc--product')) return false;
    return !!document.querySelector('.side-panel.active');
  }

  function lock() {
    if (locked) return;
    locked = true;
    // Breite der verschwindenden Scrollleiste ausgleichen (Desktop mit
    // klassischen Scrollleisten), sonst springt das Layout um diese Breite.
    var gap = window.innerWidth - root.clientWidth;
    if (gap > 0) root.style.setProperty('--s4t-scrollbar-gap', gap + 'px');
    root.classList.add('s4t-scroll-locked');
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    root.classList.remove('s4t-scroll-locked');
    root.style.removeProperty('--s4t-scrollbar-gap');
  }

  function sync() {
    if (panelOpen()) lock(); else unlock();
  }

  // Naechsten scrollbaren Vorfahren innerhalb des Panels finden
  function scroller(el, panel, vertical) {
    while (el && el !== document.body) {
      if (el.nodeType === 1) {
        var cs = getComputedStyle(el);
        if (vertical) {
          if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
        } else if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 1) {
          return el;
        }
      }
      if (el === panel) break;
      el = el.parentElement;
    }
    return null;
  }

  function onTouchStart(e) {
    if (!locked || e.touches.length !== 1) return;
    lastX = e.touches[0].clientX;
    lastY = e.touches[0].clientY;
  }

  function onTouchMove(e) {
    if (!locked || e.touches.length !== 1) return;
    var t = e.target;
    // Schieberegler (Preisfilter) und Formularfelder nicht stoeren
    if (t.closest && t.closest('input[type="range"], .noUi-target, textarea, select')) return;

    var x = e.touches[0].clientX;
    var y = e.touches[0].clientY;
    var dx = x - lastX;
    var dy = y - lastY;
    lastX = x;
    lastY = y;

    // Waagerechte Wische (Produktreihen, Bildergalerien) scrollen nie die Seite
    if (Math.abs(dx) > Math.abs(dy)) return;

    var panel = t.closest ? t.closest(PANEL) : null;
    if (!panel) {
      if (e.cancelable) e.preventDefault();
      return;
    }
    var s = scroller(t, panel, true);
    if (!s) {
      if (e.cancelable) e.preventDefault();
      return;
    }
    var atTop = s.scrollTop <= 0;
    var atBottom = s.scrollTop + s.clientHeight >= s.scrollHeight - 1;
    if ((atTop && dy > 0) || (atBottom && dy < 0)) {
      if (e.cancelable) e.preventDefault();
    }
  }

  var queued = false;
  var observer = new MutationObserver(function (records) {
    if (queued) return;
    for (var i = 0; i < records.length; i++) {
      var el = records[i].target;
      if (el === document.body || (el.classList && el.classList.contains('side-panel'))) {
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          sync();
        });
        return;
      }
    }
  });

  function start() {
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    // Zurueck-Taste aus dem Seiten-Cache: Zustand neu abgleichen
    window.addEventListener('pageshow', sync);
    sync();
  }

  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);

  window.S4TScrollLock = { sync: sync };
})();
